module.exports = __webpack_public_path__ + "img/2020-07-07.93b25157.jpg";